import { BuzzerAlert } from "../api/types/Notifications";

export const getBuzzerAlertUUID = (buzzerAlert: Partial<BuzzerAlert>) => {
  return `${buzzerAlert.device_id}__${buzzerAlert?.event_info?.timestamp}`;
}